import { render, staticRenderFns } from "./confirmationCard.vue?vue&type=template&id=10661c49&"
import script from "./confirmationCard.vue?vue&type=script&lang=js&"
export * from "./confirmationCard.vue?vue&type=script&lang=js&"
import style0 from "./confirmationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "confirmationCard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VSpacer,
})
